import React, { Component } from "react";
import { push } from "../Services/Analytics"
import ScrollableAnchor, { configureAnchors, goToAnchor } from 'react-scrollable-anchor'

import "./MakeUp.scss"

class MakeUp extends Component {
    constructor() {
        super();
        this.state = {}
    }
    linkDataLayer() {
      push("Purchase_Button_Clicked", "Purchase_MakeUp_Clicked");
    }
    render() {
        return (
            <ScrollableAnchor id="glow">
            <section className="section section-makeup">
                <div className="makeup-bg">
                    <div className="makeup-top">
                        <div className="makeup-main-title">הדרך של ניקול דנינו למראה טבעי וזוהר</div>
                        <div className="makeup-main-desc">חדש! המייק אפ שיימחק לך את הצורך במייק אפ</div>
                        <ul className="makeup-list">
                            <li><div>משפר את מראה עורך כבר בשימוש הראשון ומטפל בכתמי עור בשימוש ממושך</div></li>
                            <li><div>מכיל פיגמנטים מחזירי אור המעניקים לעור זוהר מיידי</div></li>
                            <li><div>מכיל חומצה הסליצילית לקילוף עדין המשפר את מרקם העור ומבטיח שייראה במיטבו בשימוש ממושך</div></li>
                            <li><div>מסנני <span>UVA\UVB</span> המסייעים להגן על העור מפני שינויי גוון עתידיים והזדקנות מוקדמת</div></li>
                        </ul>
                        <div className="makeup-instruct">לחצי על הנקודות כדי לגלות איך להגיע לתוצאה כזאת:</div>
                    </div>
                    <div className="dot-wrap">
                        <div className="makeup-line"></div>
                    </div>
                    <div className="popup-wrap">
                        <div className="btn_close"></div>
                        <div className="special-text">
                            <div className="special-title">מייק אפ Even Better™ Glow</div>
                            <div className="makeup-feature">
                                <div className="makeup-yes">
                                    <div className="makeup-feature-title">המייק אפ כן:</div>
                                    <ul>
                                        <li>עמיד לאורך זמן</li>
                                        <li>מטפל בכתמי עור</li>
                                        <li>עמיד במים, זיעה ולחות</li>
                                        <li>בעל מסנן קרינה <span>SPF15</span></li>
                                        <li>נטול שומן</li>
                                        <li>מתאים לכל סוגי העור</li>
                                        <li>מגיע ב־21 גוונים</li>
                                    </ul>
                                </div>
                                <div className="makeup-no">
                                    <div className="makeup-feature-title">לעומת זאת, המייק אפ לא:</div>
                                    <ul>
                                        <li>מייבש את העור</li>
                                        <li>נסדק</li>
                                        <li>סותם נקבוביות</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="pu-title"></div>
                        <div className="pu-desc"></div>
                        <a onClick={this.linkDataLayer} className="buy-btn" href="" target="_blank">לרכישה</a>
                    </div>
                </div>
            </section>
            </ScrollableAnchor>
        );
    }
}

export default MakeUp;



// WEBPACK FOOTER //
// ./src/Components/MakeUp/MakeUp.js